import { useTranslation } from "react-i18next";
import { Link } from "@tanstack/react-router";
import { Collapsible } from "@/components/ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { NavItem } from "./nav-main";
import { ThemeToggle } from "./ThemeToggle";

export function NavSettings({ items }: { items: Omit<NavItem, "permission">[] }) {
  const { t } = useTranslation();
  return (
    <SidebarGroup>
      <SidebarGroupLabel>{t("Settings")}</SidebarGroupLabel>

      <SidebarMenu>
        {items.map((item) => (
          <Collapsible key={item.title} asChild className="group/collapsible">
            <SidebarMenuItem>
              <SidebarMenuButton tooltip={t(item.title)} asChild>
                <Link to={item.url}>
                  <item.icon className="h-4 w-4 text-muted-foreground" />
                  <span className="text-muted-foreground hover:text-primary">{t(item.title)}</span>
                </Link>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </Collapsible>
        ))}
        <ThemeToggle />
      </SidebarMenu>
    </SidebarGroup>
  );
}
